import { gql } from "@apollo/client";

export const UpdateCarousel = gql`
mutation UpdateCarousel($updateCarouselId: ID!, $content: contentCarousel!) {
  updateCarousel(id: $updateCarouselId, content: $content) {
    status
  }
}
`;
